'use strict';

import $ from 'jquery';
import Backbone from 'backbone';
import _ from 'underscore';
import mediator from '../../js/mediator';
import config from '../../js/config';
import CartAPI from '../../services/CartAPI';
import utilities from '../../js/utilities';
import MerchandiseListPricingView from './MerchandiseListPricingView';
import GenericSearchModel from '../Search/genericSearchModel';
import ProductPricingService from '../../services/ProductPricingService';

var formatCurrency = require('../../utilities/globalisation').formatCurrency;
var Cart = require('../Cart/Cart').default;

const merchandiseListPricingViews = [];

var ProductMerchandiseList = Backbone.View.extend({
  events: {
    'click .ProductMerchandiseList-purchase-button': 'checkPurchase'
  },

  initialize: function() {
    this.$merchandiseList = this.$el.find('.ProductMerchandiseList-item');
    this.$totalPrice = this.$el.find('.ProductMerchandiseList-total-price');
    this.initializeProductList();
    this.create(this.$el.find('.ProductMerchandiseList'));
  },

  initializeProductList: function() {
    if (this.$totalPrice) {
      let totalPrice = parseFloat(this.$totalPrice.data('total-price'));
      totalPrice = utilities.currencyRound(totalPrice);
      this.$totalPrice.text(this.currencyFormatting(totalPrice));
    }
  },

  checkPurchase: function(e) {
    e.preventDefault();
    this.addedProducts = _.map(this.$merchandiseList, (listItem) => {
      let $listItem = $(listItem);
      let listItemData = $listItem.data('merchandising-line-item');
      let products = {
        quantity: listItemData.quantity,
        model: {
          partId: listItemData.partId,
          partSeo: listItemData.partSeo,
          partNumber: listItemData.partSeo,
          manufacturerSeo: listItemData.manufacturerSeo,
          sourceCode: listItemData.sourceCode,
          sourcePartId: listItemData.sourcePartId,
          orderIncrement: listItemData.orderIncrement,
          price: listItemData.price
        },
        isInCart: false
      };
      $listItem.find('.ProductMerchandiseList-item-purchase-info--price').text(this.currencyFormatting(listItemData.price));
      return products;
    });

    Cart.getCurrentCartState()
      .then(cart => {
        let newProducts = [];
        this.addedProducts.forEach((product) => {
          product.isInCart = !!_.findWhere(cart.entries, {catalogSourcePartId: product.model.sourcePartId});
          if (product.isInCart) {
            let args = {};
            let index = cart.entries.findIndex(cartEntry => cartEntry.catalogSourcePartId === product.model.sourcePartId);
            args.quantity = cart.entries[index].quantity + parseInt(product.quantity, 10);
            args.vendorItemNo = cart.entries[index].vendorItemNo;
            // This field is used for cart analytics: passing in item count before the update.
            args.product = {};
            args.product.quantity = cart.entries[index].quantity;
            // Update cart preview
            CartAPI.updateCartEntry(args)
              .then(function() {
                Cart.load(true);
              });
          }
          else {
            // Bundle new items in cart and add all after iterating
            newProducts.push(product);
          }
        })
        // Add all new products
        if (newProducts.length) {
          mediator.trigger(config.events.cart.addMultiple, newProducts);
        }
      });
  },

  createPricingViews: function($elements) {
    return Promise.all(
      _.map($elements, el => {
        return new Promise(resolve => {
          _.delay(() => {
            merchandiseListPricingViews.push(new MerchandiseListPricingView({ el }));
            resolve();
          });
        });
      })
    );
  },

  createModelsToLoad: function($elements) {
    this.createPricingViews($elements)
      .then(() => {
        // Unique to ensure we are not requesting the same product twice
        let uniqueViews = _.uniq(merchandiseListPricingViews, function(merchandiseListPricingView) {
          return merchandiseListPricingView.partId + merchandiseListPricingView.manufacturer + merchandiseListPricingView.partNumber;
        });

        // Get the models which are needed to request the buying options
        let models = uniqueViews.map((merchandiseListPricingView) => {
          return new GenericSearchModel({
            partId: merchandiseListPricingView.partId,
            searchResultType: config.search.resultTypeProduct
          });
        });

        _.delay(() => {
          ProductPricingService.requestPricingIfRequired(models);
        });
      });
  },

  create: function($parent) {
    // Find the views that require the pricing to be loaded
    let $elements = $parent.find('.ProductMerchandiseList-item').filter(function(n, el) {
      let $el = $(el),
        merchandiseData = $el.data('merchandising-line-item');
        // Can only find prices if we have all of the required data
      return (merchandiseData.partId || (merchandiseData.partNumber && merchandiseData.manufacturerSeo));
    });

    if (!$elements.length) {
      return;
    }

    this.createModelsToLoad($elements);
  },

  /**
   * Format price and convert currency
   *
   * @param {float|number} price
   * @returns {float}
   */
  currencyFormatting: function(price) {
    if (price) {
      let forExPrice = utilities.applyExchangeRate(price);
      return formatCurrency(forExPrice);
    }
  }

});

export function createProductMerchandiseList($parent) {
  $parent.find('.ProductMerchandiseList-wrapper').each((n, el) => new ProductMerchandiseList({ el }))
}




// WEBPACK FOOTER //
// ./assets/components/ProductMerchandiseList/ProductMerchandiseListView.js